import { render, staticRenderFns } from "./IncidentCategoryManager.vue?vue&type=template&id=43169f38&scoped=true&"
import script from "./IncidentCategoryManager.vue?vue&type=script&lang=js&"
export * from "./IncidentCategoryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43169f38",
  null
  
)

export default component.exports